import { openBlock as e, createElementBlock as a, createElementVNode as l } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, t = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M14.486 1.869a.75.75 0 0 1 1.025.274l2.774 4.8h1.875c.36-.006.711.08 1.03.246.319.167.592.41.805.703.212.292.36.629.437.983.078.355.085.723.021 1.08v.002l-1.701 9.77v.002a2.585 2.585 0 0 1-.78 1.454c-.414.38-.949.597-1.514.586H5.543c-.565.01-1.1-.206-1.513-.586a2.584 2.584 0 0 1-.78-1.454l-.001-.002-1.701-9.77v-.002a2.784 2.784 0 0 1 .021-1.08 2.64 2.64 0 0 1 .437-.983c.213-.293.486-.536.806-.703.318-.167.67-.252 1.029-.246h1.873l2.775-4.8a.75.75 0 1 1 1.299.75l-2.341 4.05h9.107l-2.341-4.05a.75.75 0 0 1 .274-1.024ZM3.506 8.517a.628.628 0 0 1 .309-.074h16.37a.628.628 0 0 1 .308.074.842.842 0 0 1 .288.256c.085.117.15.261.186.424.035.162.039.332.01.497l-.001.003-.102.588H3.125l-.102-.588v-.003a1.285 1.285 0 0 1 .01-.497c.035-.163.1-.307.186-.424a.843.843 0 0 1 .287-.256Zm-.118 3.268 1.337 7.682v.001c.047.258.167.47.319.61a.68.68 0 0 0 .472.192h12.968a.675.675 0 0 0 .472-.192c.152-.14.272-.352.319-.61v-.001l1.337-7.682H3.388Zm4.92 2.32a.75.75 0 0 1 .75-.75h5.882a.75.75 0 0 1 0 1.5H9.06a.75.75 0 0 1-.75-.75Z",
  "clip-rule": "evenodd"
}, null, -1), o = [
  t
];
function n(r, d) {
  return e(), a("svg", c, [...o]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
